<div
  id="dropdown-overlay"
  [hidden]="!dropdownOpen"
  [class.dark-overlay]="dropdownOpen?.DarkOverlay === true"
  [style.z-index]="dropdownOpen?.ZIndex"
></div>
